import { useCallback } from 'react';
import { refreshReview } from '@hydra/utils/reviewApi';
import { LanguagesTypes } from '@hydra/types';

interface RefreshReviewProps {
  url: string
  isFree?: boolean
  handleError: (error: Error) => void
  isProject?: boolean
  locale?: LanguagesTypes
}

const useRefreshReview = ({ url, isFree, handleError, isProject, locale = 'en' }: RefreshReviewProps) => {
  return useCallback(async () => {
    try {
      const { generation } = await refreshReview({ url, isFree });
      if (isProject) {
        const redirectLocation = `/${locale}/project-review/${encodeURIComponent(url)}?${new URLSearchParams({ generationId: generation.id })}`;
        window.location.href = redirectLocation;
      } else {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.append('generationId', generation.id);
        window.location.href = currentUrl.href;
      }
    } catch (error) {
      handleError(error);
    }
  }, [url, isFree, handleError, isProject, locale]);
};

export default useRefreshReview;
